import { IHttpService } from "../HttpService";
import BusinessRule, {
  IBusinessRule
} from "../../model/evaluation/BusinessRule";

export interface IBusinessRuleService {
  getBusinessRules(): Promise<IBusinessRule[]>;
  createBusinessRule(businessRule: IBusinessRule): Promise<any>;
  updateBusinessRule(businessRule: IBusinessRule): void;
}

const BusinessRuleService = (httpService): IBusinessRuleService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/";
  const _basePath = "business-rules";

  const BusinessRuleMapper = (json = []) => {
    return json.map(BusinessRule);
  };

  return {
    async getBusinessRules() {
      const path = _http.buildPath(_baseUrl, _basePath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return BusinessRuleMapper(responseJSON);
    },

    async createBusinessRule(businessRule: IBusinessRule) {
      const path = _http.buildPath(_baseUrl, _basePath);
      const response = await _http.post(path, {
        params: businessRule,
        form: true
      });
      return _http.toText(response);
    },

    async updateBusinessRule(businessRule: IBusinessRule) {
      const path = _http.buildPath(
        _baseUrl,
        _basePath,
        businessRule.id.toString()
      );
      const response = await _http.put(path, {
        params: businessRule,
        form: true
      });
      return _http.toText(response);
    }
  };
};

export default BusinessRuleService;
